<template>
  <section class="closefriend-hero ">
    <b @click="slideBar()" :class="showSlideBar ? 'screen-overlay show' : 'screen-overlay'"></b>
    <influencer-menu @menuClicked="slideBar()" :show-slide-bar="showSlideBar"></influencer-menu>
    <header-menu @slideMenu="slideBar()" :is-loading="isLoading"></header-menu>

    <div class="container-fluid mt-3">
      <div class="row justify-content-center">
        <div class="col-12 px-2 px-md-4" style="max-width: 1200px;">
          <global-message />

          <!-- Header with Broadcast Button -->
          <div class="d-flex flex-wrap align-items-center justify-content-between mb-4 mt-2 px-1 gap-2">
            <div>
              <h5 class="text-white font-weight-700 mb-0 font-size-20">Messages</h5>
              <span class="text-muted font-size-12">{{ inboxCount }} unread messages</span>
            </div>
            <button type="button" class="cp-btn-primary d-inline-flex align-items-center" @click="$router.push({name: 'Announcement', query: {newFilter: true, inboxCount}})">
              <i class="fa fa-bullhorn me-2 font-size-12"></i> Broadcast
            </button>
          </div>

          <!-- Tab Navigation -->
          <div class="d-flex flex-wrap align-items-center mb-4">
            <span 
              class="badge filter-pill cursor-pointer me-2 mb-2" 
              :class="activeTab === 'dashboard' ? 'active' : ''"
              @click="activeTab = 'dashboard'">
              <i class="fa fa-chart-bar me-1"></i> Stats
            </span>
            <span 
              class="badge filter-pill cursor-pointer me-2 mb-2" 
              :class="activeTab === 'inbox' ? 'active' : ''"
              @click="activeTab = 'inbox'">
              <i class="fa fa-envelope me-1"></i> Inbox
              <span class="msg-inbox-badge ms-1">{{ inboxCount }}</span>
            </span>
            <span 
              class="badge filter-pill cursor-pointer me-2 mb-2" 
              :class="activeTab === 'groups' ? 'active' : ''"
              @click="activeTab = 'groups'">
              <i class="fa fa-users me-1"></i> Announcement
            </span>
            <span 
              class="badge filter-pill cursor-pointer me-2 mb-2" 
              :class="activeTab === 'settings' ? 'active' : ''"
              @click="activeTab = 'settings'">
              <i class="fa fa-cog me-1"></i> Settings
            </span>
          </div>

          <!-- ======================== -->
          <!-- TAB: Dashboard           -->
          <!-- ======================== -->
          <template v-if="activeTab === 'dashboard'">
            <!-- Revenue Card -->
            <div class="login-card mx-auto mb-3 p-3 p-md-4">
              <h6 class="text-white font-weight-500 mb-4">
                <i class="fa fa-chart-line me-2" style="color: #80CBFE;"></i>Message Revenue
              </h6>
              <div class="row">
                <div v-for="(period, index) in ['DAY', 'WEEK', 'MONTH', 'YEAR']" :key="period" class="col-6 col-md-3 mb-3 mb-md-0">
                  <div class="d-flex flex-column h-100 position-relative px-2">
                    <p class="text-muted font-size-12 text-uppercase letter-spacing-1 mb-2">{{ period }}</p>
                    <div class="d-flex align-items-baseline mb-2">
                      <span class="revenue-amount me-2">${{ Math.round(revenues[period].revenue || 0).toLocaleString() }}</span>
                    </div>
                    <div>
                      <span 
                        class="revenue-growth-badge" 
                        :class="revenues[period].growthPercentage < 0 ? 'negative' : ''">
                        <i class="fa" :class="revenues[period].growthPercentage < 0 ? 'fa-arrow-down' : 'fa-arrow-up'"></i>
                        {{ Math.abs(revenues[period].growthPercentage || 0) }}%
                      </span>
                    </div>
                    <!-- Divider for desktop -->
                    <div v-if="index < 3" class="d-none d-md-block position-absolute" style="right: 0; top: 10%; height: 80%; width: 1px; background: rgba(255,255,255,0.1);"></div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Top Subscribers Card -->
            <div class="login-card mx-auto mb-3 p-3 p-md-4">
              <h6 class="text-white font-weight-500 mb-3">Top Subscribers</h6>
              <div v-if="topFans.length === 0" class="text-center py-4">
                <p class="text-white font-size-14 mb-0" style="opacity: 0.5;">No top subscribers data yet</p>
              </div>
              <div v-else>
                <div 
                  v-for="(topFan, index) in topFans" :key="index"
                  class="msg-subscriber-row"
                  @click="openDirectMessage(topFan.customerId)">
                  <div class="d-flex align-items-center">
                    <span class="msg-rank-badge me-3">{{ index + 1 }}</span>
                    <img class="rounded-circle me-3" width="40" height="40" src="@/assets/images/stella/no_avatar.png" alt="">
                    <span class="text-white font-size-14 font-weight-500">{{ topFan.name }}</span>
                  </div>
                  <span class="msg-spent-amount">${{ topFan.spent }}</span>
                </div>
              </div>
            </div>
          </template>

          <!-- ======================== -->
          <!-- TAB: Inbox               -->
          <!-- ======================== -->
          <template v-if="activeTab === 'inbox'">
            <div class="login-card mx-auto mb-3 p-3 p-md-4">
              <div class="d-flex flex-wrap align-items-center justify-content-between mb-4">
                <div class="d-flex align-items-center flex-wrap mb-2 mb-md-0">
                  <h6 class="text-white font-weight-500 mb-0 me-3">Messages</h6>
                  <span class="badge cursor-pointer me-2" 
                        style="background: linear-gradient(135deg, #ff6ec7, #f9a826);"
                        @click="toggleUnreadFilter"
                        title="Click to filter unread threads">
                    {{ inboxCount }} Unread
                  </span>
                  <span v-if="unreadFilterActive" class="badge me-2" style="background: rgba(229,59,185,0.15); border: 1px solid #E53BB9; border-radius: 20px; color: #E53BB9; cursor: pointer;" @click="clearUnreadFilter">
                    Unread only <i class="fa fa-times ms-1"></i>
                  </span>
                  <span class="text-muted font-size-12 me-2">{{ displayedSubscribers.length }} conversations</span>
                </div>

                <div class="position-relative" style="width: 100%; max-width: 260px;">
                  <i class="fa fa-search position-absolute text-muted" style="left: 12px; top: 10px;"></i>
                  <input type="text" class="w-100 font-size-13" style="padding-left: 36px; padding-right: 32px; padding-top: 8px; padding-bottom: 8px; border-radius: 20px; background: rgba(255,255,255,0.05); border: 1px solid rgba(255,255,255,0.1); color: #fff; transition: all 0.2s ease; outline: none;" 
                         placeholder="Search subscribers..." v-model="searchQuery"
                         @keyup.enter="search(searchQuery)" @keyup="searchInput(searchQuery)"
                         onfocus="this.style.borderColor='rgba(255,255,255,0.3)'; this.style.background='rgba(255,255,255,0.08)';"
                         onblur="this.style.borderColor='rgba(255,255,255,0.1)'; this.style.background='rgba(255,255,255,0.05)';" >
                  <span v-if="searchQuery" class="position-absolute cursor-pointer text-muted font-size-16" style="right: 12px; top: 8px;" @click="clearSearch">&times;</span>
                </div>
              </div>
              <div v-if="isInboxLoading" class="py-4">
                <div v-for="i in 4" :key="i" class="msg-inbox-row d-flex align-items-center mb-2" style="border-color: rgba(255,255,255,0.05); cursor: default;">
                  <div class="me-3 flex-shrink-0" style="width: 48px; height: 48px; border-radius: 50%; background: rgba(255,255,255,0.05); animation: pulse 1.5s infinite;"></div>
                  <div class="flex-grow-1">
                    <div style="height: 14px; background: rgba(255,255,255,0.08); width: 30%; border-radius: 4px; margin-bottom: 8px; animation: pulse 1.5s infinite;"></div>
                    <div style="height: 12px; background: rgba(255,255,255,0.04); width: 60%; border-radius: 4px; animation: pulse 1.5s infinite;"></div>
                  </div>
                </div>
              </div>
              
              <div v-else-if="subscribers.length === 0" class="text-center py-5">
                <div class="stella-empty-state-icon mb-3">
                  <i class="fa fa-envelope font-size-22" style="opacity: 0.4; color: #E53BB9;"></i>
                </div>
                <h5 class="text-white font-weight-500 mb-2" style="opacity: 0.6;">No messages yet</h5>
                <p class="text-white font-size-14 mb-0" style="opacity: 0.35;">
                  Messages from your subscribers will appear here.
                </p>
              </div>

              <div v-else>
                <div 
                  v-for="(subscriber, index) in displayedSubscribers" :key="index"
                  class="msg-inbox-row cursor-pointer"
                  :class="{ 'unread-thread': isUnread(subscriber) }"
                  @click="openDirectMessage(subscriber.id)">
                  <div class="d-flex align-items-center" style="min-width: 0;">
                    <div class="position-relative me-3 flex-shrink-0">
                      <message-avatar :user-id="subscriber.id"/>
                      <span v-if="isUnread(subscriber)" class="msg-unread-dot-badge position-absolute"></span>
                    </div>
                    <div class="flex-grow-1" style="min-width: 0;">
                      <div class="d-flex align-items-center justify-content-between">
                        <span class="font-size-14 text-truncate" 
                              :class="isUnread(subscriber) ? 'text-white font-weight-700' : 'text-white font-weight-500'" 
                              :title="subscriber.name ? subscriber.name : subscriber.email">
                          {{ subscriber.name ? subscriber.name : subscriber.email }}
                        </span>
                        <span class="font-size-12 ms-2 flex-shrink-0" 
                              :class="isUnread(subscriber) ? 'text-white font-weight-600' : 'text-muted'" 
                              v-if="subscriber.lastChat">
                          {{ timeSince(subscriber.lastChat.sentAt) }}
                        </span>
                      </div>
                      <div class="d-flex align-items-center justify-content-between mt-1" v-if="subscriber.lastChat">
                        <p class="font-size-12 mb-0 message-preview text-truncate" 
                           :class="isUnread(subscriber) ? 'text-white font-weight-500' : 'text-muted'" 
                           :title="subscriber.lastChat.message"
                           :style="isUnread(subscriber) ? 'opacity: 0.9;' : ''">
                           {{ cropMessage(subscriber.lastChat) }}
                        </p>
                        <span v-if="isUnread(subscriber)" class="msg-unread-badge ms-2">
                          {{ (subscriber.unreadCount && subscriber.unreadCount > 0) ? subscriber.unreadCount : '1' }}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </template>

          <!-- ======================== -->
          <!-- TAB: Settings            -->
          <!-- ======================== -->
          <template v-if="activeTab === 'settings'">
            <!-- Pricing Card -->
            <div class="login-card mx-auto mb-3 p-3 p-md-4">
              <h6 class="text-white font-weight-500 mb-3">
                <i class="fa fa-dollar-sign me-2" style="color: #55EFC4;"></i>Pricing
              </h6>
              <div class="row">
                <div class="col-12 col-md-6 mb-3">
                  <label class="msg-input-label">Price per message</label>
                  <input type="number" min="0" class="msg-input w-100"
                         @keyup.enter="saveChatSetting"
                         @focusout="saveChatSetting"
                         v-model="chatSetting.pricePerMessage"
                         placeholder="0"
                         onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57">
                </div>
                <div class="col-12 col-md-6 mb-3">
                  <label class="msg-input-label">Price per picture</label>
                  <input type="number" min="0" class="msg-input w-100"
                         @keyup.enter="saveChatSetting"
                         @focusout="saveChatSetting"
                         v-model="chatSetting.pricePerFile"
                         placeholder="0"
                         onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57">
                </div>
              </div>
              <p class="text-muted font-size-12 mb-0">You can set a custom price before you send media.</p>
            </div>

            <!-- Welcome Message Card -->
            <div class="login-card mx-auto mb-3 p-3 p-md-4">
              <div class="d-flex align-items-center justify-content-between mb-3">
                <h6 class="text-white font-weight-500 mb-0">
                  <i class="fa fa-comment-dots me-2" style="color: #80CBFE;"></i>Welcome Message
                </h6>
                <label class="msg-toggle">
                  <input type="checkbox" @change="welcomeMessageRequiredChanged"
                         v-model="chatSetting.welcomeMessageRequired">
                  <span class="msg-toggle-slider"></span>
                </label>
              </div>
              <p class="text-muted font-size-12 mb-2">Auto-send to new subscribers</p>
              <div class="d-flex align-items-end p-2 mt-2" 
                   style="border-radius: 24px; background: rgba(255, 255, 255, 0.05);" 
                   :style="chatSetting.welcomeMessageRequired ? '' : 'opacity: 0.5; pointer-events: none;'">
                <textarea class="w-100 text-white mx-2 py-2 border-0 bg-transparent"
                          style="resize: none; outline: none; min-height: 40px; max-height: 120px;"
                          :disabled="!chatSetting.welcomeMessageRequired"
                          @blur="saveChatSetting"
                          v-model="chatSetting.welcomeMessage"
                          rows="2"
                          placeholder="Write your welcome message here..."></textarea>
              </div>
            </div>
          </template>

          <!-- ======================== -->
          <!-- TAB: Groups              -->
          <!-- ======================== -->
          <template v-if="activeTab === 'groups'">
            <div class="login-card mx-auto mb-3 p-3 p-md-4">
              <div class="d-flex flex-wrap align-items-center justify-content-between mb-3 gap-2">
                <h6 class="text-white font-weight-600 mb-0 font-size-16">
                  <i class="fa fa-users me-2" style="color: #F1C40F;"></i>Announcement Groups
                </h6>
                <button type="button" class="cp-btn-primary d-inline-flex align-items-center" @click="$refs.filterModal.show(null)">
                  <i class="fa fa-plus me-1 font-size-12"></i> New Filter
                </button>
              </div>

              <div v-if="isGroupsLoading" class="py-4">
                <div v-for="i in 3" :key="i" class="msg-filter-row d-flex align-items-center mb-2" style="border-color: rgba(255,255,255,0.05); cursor: default;">
                  <div class="msg-filter-icon me-3" style="background: rgba(255,255,255,0.05); border-color: transparent; animation: pulse 1.5s infinite;"></div>
                  <div class="flex-grow-1">
                    <div style="height: 14px; background: rgba(255,255,255,0.08); width: 25%; border-radius: 4px; margin-bottom: 8px; animation: pulse 1.5s infinite;"></div>
                    <div style="height: 12px; background: rgba(255,255,255,0.04); width: 45%; border-radius: 4px; animation: pulse 1.5s infinite;"></div>
                  </div>
                </div>
              </div>

              <div v-else-if="filterSettings.length === 0" class="text-center py-4">
                <p class="text-white font-size-14 mb-0" style="opacity: 0.5;">No groups created yet</p>
              </div>

              <div v-else>
                <div 
                  v-for="(filterSetting, index) in filterSettings" :key="index"
                  class="msg-filter-row" @click="goToAnnouncement(filterSetting)">
                  <div class="d-flex align-items-center" style="min-width: 0; flex-grow: 1;">
                    <div class="msg-filter-icon me-3 flex-shrink-0">
                      <i class="fa fa-users"></i>
                    </div>
                    <div class="flex-grow-1" style="min-width: 0;">
                      <span class="text-white font-size-14 font-weight-500 text-truncate d-block" :title="filterSetting.name">{{ filterSetting.name }}</span>
                      <p class="text-muted font-size-12 mb-0 mt-1">{{ filterSetting.customerCount }} subscribers</p>
                      <div class="d-flex align-items-center mt-1" v-if="filterSetting.latestChat">
                        <p class="font-size-12 text-muted mb-0 message-preview text-truncate flex-grow-1" :title="`You: ${filterSetting.latestChat.message}`">
                           You: {{ cropMessage(filterSetting.latestChat) }}</p>
                      </div>
                    </div>
                  </div>
                  <div class="d-flex align-items-center" v-if="filterSetting.userDefined">
                    <span class="msg-action-btn cursor-pointer me-2" @click.stop="$refs.filterModal.show(filterSetting)">
                      <i class="fa fa-edit"></i>
                    </span>
                    <span class="msg-action-btn cursor-pointer msg-action-delete" @click.stop="filterToDelete = filterSetting; $refs.confirmDelete.show();">
                      <i class="fa fa-trash"></i>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </template>

        </div>
      </div>
    </div>

    <model-confirm-delete
      id="delete_model"
      ref="confirmDelete"
      text="Are you sure you want to delete?"
      button-color="btn-danger border-0"
      confirm-btn-txt="Delete"
      @confirm="confirmDeleteFilter"
    />

    <filter-modal ref="filterModal" @saved="createdOrUpdatedFilter"/>

  </section>
</template>

<script>
import FilterModal from '@/components/module/influencer/direct-message/FilterModal';
import {SERVICE_CONTENT, SERVICE_DIRECT_MESSAGE, SERVICE_SUBSCRIPTION} from "@/properties/micro-service";
import {mapActions, mapGetters} from "vuex";
import { CONTENT_TYPE_IMAGE, CONTENT_TYPE_VIDEO } from "@/properties/content-type";
import { cropMessage, scroll } from "@/common/Utils";
import {httpMixin} from "@/mixin/http-mixin";
import {required} from "vuelidate/lib/validators";

import InfluencerMenu from "@/components/module/influencer/shared/InfluencerMenu";
import HeaderMenu from "@/components/module/influencer/shared/HeaderMenu";
import '@/assets/styles/direct-message/direct-message-common.css';
import GlobalMessage from "@/components/module/shared/GlobalMessage";
import {timeSince} from "@/common/datetime-service";
import MessageAvatar from "@/components/module/shared/direct-message/MessageAvatar";
import PwaActionBar from "@/components/module/influencer/shared/PwaActionBar";
import {constructCustomerURL} from "@/common/baseURL-service";
import titleMixin from "../../../../mixin/title-mixin";
import ModelConfirmDelete from "@/components/module/shared/ModelBasic";


export default {
  name: "CreatorMessageDashboard",
  title: 'Messages',
  components: {MessageAvatar, FilterModal, InfluencerMenu, HeaderMenu, GlobalMessage, PwaActionBar, ModelConfirmDelete},
  mixins: [httpMixin, titleMixin],
  data() {
    return {
      activeTab: 'dashboard',
      subscribers: [],
      filterSettings: [],
      chatSetting: {},
      isSubmitted: false,
      topFans: [],
      revenues: {
        DAY: { revenue: 0, growthPercentage: 0 },
        WEEK: { revenue: 0, growthPercentage: 0 },
        MONTH: { revenue: 0, growthPercentage: 0 },
        YEAR: { revenue: 0, growthPercentage: 0 }
      },
      inboxCount: 0,
      unreadFilterActive: false,
      unreadSubscribers: [],
      showSlideBar: false,
      filterToDelete: null,
      isInboxLoading: true,
      isDashboardLoading: true,
      isGroupsLoading: true,
      isSettingsLoading: true,
      isPageShort: false,
      isAtTop: true,
      isAtBottom: false,
      searchQuery: ''
    }
  },
  validations() {
    let chatSetting = {};
    if (this.chatSetting.messageChargeRequired) {
      chatSetting.pricePerMessage = {required};
      chatSetting.pricePerFile = {required};
    }
    if (this.chatSetting.welcomeMessageRequired) {
      chatSetting.welcomeMessage = {required};
    }
    return {chatSetting};
  },
  created() {
    if (this.$route.query.tab) {
      this.activeTab = this.$route.query.tab;
    }
    this.clearGlobalMessages();
    if (this.getUser && this.getUser.id) {
      this.getSubscribersLatestMessage();
    }
  },
  mounted() {
    if (this.getUser && this.getUser.id) {
      this.getFilter();
    }
  },
  beforeDestroy() {
  },
  computed: {
    ...mapGetters(['getUser']),
    displayedSubscribers() {
      return this.unreadFilterActive ? this.unreadSubscribers : this.subscribers;
    },
  },
  watch: {
    getUser: {
      immediate: true,
      handler(user) {
        if (user && user.id) {
          if (!this.subscribers || this.subscribers.length === 0) {
            this.getSubscribersLatestMessage();
          }
          if (!this.filterSettings || this.filterSettings.length === 0) {
            this.getFilter();
          }
        }
      }
    }
  },
  methods: {
    cropMessage,
    ...mapActions(['setMessage', 'pushGlobalError']),
    timeSince,
    constructCustomerURL,
    getTopFans() {
      if (!this.getUser || !this.getUser.id) {
        this.isDashboardLoading = false;
        return;
      }
      this.isDashboardLoading = true;
      let url = `${SERVICE_SUBSCRIPTION}/api/v1/influencers/${this.getUser.id}/message-top-fan`;
      this.getData(url, (topFans) => {
        this.topFans = topFans;
        this.isDashboardLoading = false;
      }, true);
    },
    search(searchQuery) {
      this.searchQuery = searchQuery;
      if (searchQuery.length < 3) {
        if (searchQuery.length === 0) {
           this.getSubscribersLatestMessage();
        }
        return;
      }
      this.isInboxLoading = true;
      let url = `${SERVICE_DIRECT_MESSAGE}/api/v1/chat/chat-messages/influencers/${this.getUser.id}/latest?searchKey=${searchQuery}`;
      this.getData(url, (lastChatData) => {
        let lastChats = lastChatData.chatMessages ? lastChatData.chatMessages : [];
        let users = lastChatData.users ? lastChatData.users : [];
        let freshSubscribers = [];
        lastChats.forEach((lastChat) => {
          let index = users.findIndex(sub => sub.id === lastChat.senderId || sub.id === lastChat.receiverId);
          if (index !== -1) {
            let sub = users[index];
            sub.lastChat = lastChat;
            sub.hasUnreadBuried = false;
            freshSubscribers.push(sub);
          }
        });
        this.subscribers = freshSubscribers;
        this.sortSubscribers();
        this.isInboxLoading = false;
      });
    },
    searchInput(searchQuery) {
      if (!searchQuery) {
        this.clearSearch();
      }
    },
    clearSearch() {
      this.searchQuery = '';
      this.getSubscribersLatestMessage();
    },
    getAllRevenues() {
      const periods = ['DAY', 'WEEK', 'MONTH', 'YEAR'];
      let completed = 0;
      periods.forEach(period => {
        let url = `${SERVICE_SUBSCRIPTION}/api/v1/influencers/${this.getUser.id}/message-revenue?revenueType=${period}`;
        this.getData(url, (revenue) => {
          if (revenue) {
            this.revenues[period] = revenue;
          }
          completed++;
        }, true);
      });
    },
    getSubscribersLatestMessage() {
      if (!this.getUser || !this.getUser.id) {
        this.isInboxLoading = false;
        return;
      }
      this.isInboxLoading = true;
      let url = `${SERVICE_DIRECT_MESSAGE}/api/v1/chat/chat-messages/influencers/${this.getUser.id}/latest?size=500`;
      this.getData(url, (lastChatData) => {
        let lastChats = lastChatData.chatMessages ? lastChatData.chatMessages : [];
        this.inboxCount = lastChatData.unreadMessageCount;
        let users = lastChatData.users ? lastChatData.users: [];
        let freshSubscribers = [];
        lastChats.forEach((lastChat) => {
          let index = users.findIndex(sub => sub.id === lastChat.senderId || sub.id === lastChat.receiverId);
          if (index !== -1) {
            let sub = users[index];
            sub.lastChat = lastChat;
            sub.hasUnreadBuried = false;
            if (!sub.unreadCount) sub.unreadCount = 0;
            if (!lastChat.read && lastChat.senderId !== this.getUser.id) {
              sub.unreadCount = 1;
              this.fetchUnreadCountForThread(sub);
            }
            freshSubscribers.push(sub);
          }
        });
        
        this.subscribers = freshSubscribers;
        this.sortSubscribers();
        
        if (this.inboxCount > 0) {
          this.deepScanForUnread();
          this.ensureUnreadThreadsVisible();
        }
        
        this.isInboxLoading = false;
        this.getFilter();
        this.getChatSetting();
        this.getTopFans();
        this.getAllRevenues();
      }, true);
    },
    fetchUnreadCountForThread(subscriber) {
      const url = `${SERVICE_DIRECT_MESSAGE}/api/v1/chat/chat-messages/influencers/${this.getUser.id}/receiver/${subscriber.id}`;
      this.getData(url, (messages) => {
        const count = messages.filter(m => !m.read && m.senderId !== this.getUser.id).length;
        if (count > 0) {
          this.$set(subscriber, 'unreadCount', count);
        }
      });
    },
    ensureUnreadThreadsVisible() {
      const url = `${SERVICE_DIRECT_MESSAGE}/api/v1/chat/chat-messages/influencers/${this.getUser.id}/latest/unread`;
      this.getData(url, (data) => {
        const lastChats = data.chatMessages || [];
        const users = data.users || [];
        lastChats.forEach((lastChat) => {
          const senderId = lastChat.senderId;
          const receiverId = lastChat.receiverId;
          const existing = this.subscribers.find(s => s.id === senderId || s.id === receiverId);
          if (existing) {
            this.$set(existing, 'hasUnreadBuried', true);
          } else {
            const idx = users.findIndex(u => u.id === senderId || u.id === receiverId);
            if (idx !== -1) {
              const sub = users[idx];
              sub.lastChat = lastChat;
              sub.hasUnreadBuried = true;
              this.subscribers.unshift(sub);
            }
          }
        });
        this.sortSubscribers();
      });
    },
    sortSubscribers() {
      const sorted = [...this.subscribers].sort((a, b) => {
        const aUnread = this.isUnread(a);
        const bUnread = this.isUnread(b);
        if (aUnread && !bUnread) return -1;
        if (!aUnread && bUnread) return 1;
        const aTime = (a.lastChat && a.lastChat.sentAt) ? new Date(a.lastChat.sentAt).getTime() : 0;
        const bTime = (b.lastChat && b.lastChat.sentAt) ? new Date(b.lastChat.sentAt).getTime() : 0;
        return bTime - aTime;
      });
      
      const unique = [];
      const seen = new Set();
      for (const s of sorted) {
        if (!seen.has(s.id)) {
          seen.add(s.id);
          unique.push(s);
        }
      }
      this.subscribers = unique;
    },
    async deepScanForUnread() {
      const candidates = this.subscribers.filter(s =>
        s.lastChat &&
        s.lastChat.senderId === this.getUser.id &&
        s.lastChat.read === false &&
        !s.hasUnreadBuried
      ).slice(0, 30);
      for (const sub of candidates) {
        const url = `${SERVICE_DIRECT_MESSAGE}/api/v1/chat/chat-messages/influencers/${this.getUser.id}/receiver/${sub.id}`;
        this.getData(url, (messages) => {
          const hasUnread = messages.some(m => !m.read && m.senderId !== this.getUser.id);
          if (hasUnread) {
            this.$set(sub, 'hasUnreadBuried', true);
            this.sortSubscribers();
          }
        });
      }
    },
    getFilter() {
      if (!this.getUser || !this.getUser.id) {
        this.isGroupsLoading = false;
        return;
      }
      this.isGroupsLoading = true;
      let url = `${SERVICE_DIRECT_MESSAGE}/api/v1/chat/filter-settings/influencers/${this.getUser.id}`;
      this.getData(url, (filterSettings) => {
        this.filterSettings = filterSettings;
        this.isGroupsLoading = false;
      }, true);
    },
    refreshFilterGroups() {
      this.getFilter();
    },
    createdOrUpdatedFilter(filter) {
      let index = this.filterSettings.findIndex((item) => item.id === filter.id);
      if (index !== -1) {
        this.$set(this.filterSettings, index, filter);
      } else {
        this.filterSettings.push(filter);
      }
      this.setMessage("Announcement group saved successfully.");
    },
    welcomeMessageRequiredChanged(event) {
      if (!event.target.checked) {
        this.chatSetting.welcomeMessage = null;
        this.saveChatSetting();
      }
    },
    getChatSetting() {
      this.isSettingsLoading = true;
      let url = `${SERVICE_DIRECT_MESSAGE}/api/v1/chat/message-settings/influencers/${this.getUser.id}`;
      this.getData(url, (chatSetting) => {
        if (chatSetting) {
          this.chatSetting = chatSetting;
        }
        this.isSettingsLoading = false;
      }, true);
    },
    openDirectMessage(customerId) {
      if (customerId) {
        localStorage.setItem('selectedSubscriberId', String(customerId));
      }
      this.$router.push({ name: 'CreatorDirectMessage', params: { customerId: customerId } });
    },
    saveChatSetting() {
      this.isSubmitted = true;
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }

      let url = `${SERVICE_DIRECT_MESSAGE}/api/v1/chat/message-settings/influencers/${this.getUser.id}`;
      this.chatSetting.influencerId = this.getUser.id;
      this.putData(url, this.chatSetting, (chatSetting) => {
        this.chatSetting = chatSetting;
        this.isSubmitted = false;
        this.setMessage('Chat settings saved successfully.');
      });
    },
    confirmDeleteFilter() {
      let filter = this.filterToDelete;
      if(!filter) return;
      if(this.$refs.confirmDelete) this.$refs.confirmDelete.hide();
      
      let filterId = filter.id;
      let url = `${SERVICE_DIRECT_MESSAGE}/api/v1/chat/filter-settings/influencers/${this.getUser.id}/filters/${filterId}`;
      this.deleteData(url, (_) => {
        let index = this.filterSettings.findIndex(f => f.id === filter.id);
        if (index !== -1) {
          this.filterSettings.splice(index, 1);
        }
        this.filterToDelete = null;
        this.setMessage("Announcement group deleted successfully.");
      });
    },
    slideBar() {
      this.showSlideBar = !this.showSlideBar;
    },
    goToAnnouncement(filterSetting) {
      localStorage.setItem('selectedAnnocmcementId', filterSetting.id);
      this.$router.push({name: 'Announcement', query: {inboxCount: this.inboxCount}});
    },
    formatMessage(message) {
      if (message) {
        const urlPattern = /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])|(\b(www\.[\S]+))/gi;
        return message.replace(urlPattern, url => {
          const href = url.startsWith('www.') ? `http://${url}` : url;
          return `<a href="${href}" target="_blank" rel="noopener noreferrer">${url}</a>`;
        });
      } else {
        return 'N/A'
      }
    },
    toggleUnreadFilter() {
      if (this.unreadFilterActive) {
        this.clearUnreadFilter();
        return;
      }
      this.unreadFilterActive = true;
      const url = `${SERVICE_DIRECT_MESSAGE}/api/v1/chat/chat-messages/influencers/${this.getUser.id}/latest/unread`;
      this.getData(url, (data) => {
        let lastChats = data.chatMessages || [];
        let users = data.users || [];
        let result = [];
        lastChats.forEach((lastChat) => {
          let index = users.findIndex(u => u.id === lastChat.senderId || u.id === lastChat.receiverId);
          if (index !== -1) {
            let sub = users[index];
            sub.lastChat = lastChat;
            sub.hasUnreadBuried = this.isUnread(sub);
            result.push(sub);
          }
        });
        this.unreadSubscribers = result;
      });
    },
    clearUnreadFilter() {
      this.unreadFilterActive = false;
      this.unreadSubscribers = [];
    },
    isUnread(subscriber) {
      if (!subscriber) return false;
      if (subscriber.hasUnreadBuried) return true;
      if (this.unreadFilterActive && this.unreadSubscribers && this.unreadSubscribers.some(u => u.id === subscriber.id)) return true;
      if (this.unreadSubscribers && this.unreadSubscribers.some(u => u.id === subscriber.id)) return true;
      return !!(subscriber.lastChat && (
        subscriber.lastChat.new ||
        (!subscriber.lastChat.read && subscriber.lastChat.senderId !== this.getUser.id)
      ));
    },
  }
}

</script>

<style scoped>
.closefriend-hero {
  background-color: #111111 !important;
  background-image: none !important;
  min-height: 100vh;
}

/* Tab Pills */
.filter-pill {
  background-color: rgba(255, 255, 255, 0.05);
  color: rgba(255, 255, 255, 0.6);
  border: 1px solid rgba(255, 255, 255, 0.1);
  padding: 8px 16px;
  border-radius: 20px;
  font-weight: 500;
  font-size: 13px;
  transition: all 0.2s ease;
}
.filter-pill:hover {
  background-color: rgba(255, 255, 255, 0.1);
  color: #fff;
}
.filter-pill.active {
  background-color: #E53BB9;
  color: #fff;
  border-color: transparent;
}

/* Revenue */
.revenue-amount {
  color: #fff;
  font-size: 24px;
  font-weight: 600;
}
.revenue-growth-badge {
  background: #55EFC4;
  color: #000;
  padding: 3px 10px;
  border-radius: 8px;
  font-weight: 600;
  font-size: 13px;
}
.revenue-growth-badge.negative {
  background: #FF4B81;
  color: #fff;
}

/* Top Subscribers */
.msg-subscriber-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
  cursor: pointer;
  transition: background 0.15s ease;
}
.msg-subscriber-row:last-child {
  border-bottom: none;
}
.msg-subscriber-row:hover {
  background: rgba(255, 255, 255, 0.03);
  margin: 0 -16px;
  padding: 12px 16px;
  border-radius: 8px;
}
.msg-rank-badge {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: linear-gradient(135deg, #F3DA6B, #E53BB9);
  color: #000;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 12px;
  flex-shrink: 0;
}
.msg-spent-amount {
  color: #55EFC4;
  font-weight: 600;
  font-size: 16px;
}

/* Inbox */
.msg-inbox-badge {
  background: linear-gradient(90deg, #F3DA6B 0%, #E53BB9 100%);
  color: #fff;
  padding: 1px 7px;
  border-radius: 10px;
  font-size: 11px;
  font-weight: 600;
}
.msg-inbox-row {
  border: 1px solid rgba(255, 255, 255, 0.1) !important;
  border-radius: 12px;
  padding: 16px !important;
  margin-bottom: 12px !important;
  background: rgba(255, 255, 255, 0.02);
  transition: all 0.2s ease;
  cursor: pointer;
}
.msg-inbox-row:hover {
  background: rgba(255, 255, 255, 0.05) !important;
  border-color: rgba(255, 255, 255, 0.2) !important;
}

.msg-inbox-row.unread-thread {
  background: rgba(229, 59, 185, 0.08) !important;
  border-color: rgba(229, 59, 185, 0.4) !important;
  box-shadow: inset 3px 0 0 #E53BB9, 0 2px 12px rgba(229, 59, 185, 0.12);
}

.msg-inbox-row.unread-thread:hover {
  background: rgba(229, 59, 185, 0.12) !important;
  border-color: rgba(229, 59, 185, 0.6) !important;
}

.msg-unread-dot-badge {
  top: -2px;
  right: -2px;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: linear-gradient(135deg, #F3DA6B, #E53BB9);
  border: 2px solid #111;
  box-shadow: 0 0 8px rgba(229, 59, 185, 0.8);
}

.msg-new-badge {
  background: #55EFC4;
  padding: 2px 8px;
  font-size: 11px;
  color: #000;
  border-radius: 4px;
  font-weight: 600;
  flex-shrink: 0;
}
.msg-unread-badge {
  background: linear-gradient(135deg, #E53BB9, #ff6ec7);
  color: #fff;
  font-size: 11px;
  font-weight: 700;
  padding: 2px 8px;
  border-radius: 12px;
  min-width: 20px;
  text-align: center;
  flex-shrink: 0;
  box-shadow: 0 2px 8px rgba(229, 59, 185, 0.4);
}

/* Settings */
.msg-input-label {
  color: rgba(255, 255, 255, 0.5);
  font-size: 12px;
  margin-bottom: 6px;
  display: block;
}
.msg-input {
  background-color: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 10px;
  padding: 10px 14px;
  color: #fff;
  font-size: 14px;
  transition: border-color 0.2s ease;
}
.msg-input:focus {
  outline: none;
  border-color: #E53BB9;
}
.msg-input:disabled {
  opacity: 0.4;
}
.msg-textarea {
  background-color: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 10px;
  padding: 12px 14px;
  color: #fff;
  font-size: 14px;
  resize: vertical;
  transition: border-color 0.2s ease;
}
.msg-textarea:focus {
  outline: none;
  border-color: #E53BB9;
}
.msg-textarea:disabled {
  opacity: 0.4;
}

/* Toggle Switch */
.msg-toggle {
  position: relative;
  display: inline-block;
  width: 44px;
  height: 22px;
  margin: 0;
}
.msg-toggle input {
  opacity: 0;
  width: 0;
  height: 0;
}
.msg-toggle-slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(255, 255, 255, 0.15);
  transition: 0.3s;
  border-radius: 22px;
}
.msg-toggle-slider:before {
  position: absolute;
  content: "";
  height: 18px;
  width: 18px;
  left: 2px;
  bottom: 2px;
  background-color: #fff;
  transition: 0.3s;
  border-radius: 50%;
}
.msg-toggle input:checked + .msg-toggle-slider {
  background-color: #55EFC4;
}
.msg-toggle input:checked + .msg-toggle-slider:before {
  transform: translateX(22px);
}

/* Filters */
.msg-filter-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
}
.msg-filter-row:last-child {
  border-bottom: none;
}
.msg-filter-icon {
  width: 36px;
  height: 36px;
  border-radius: 10px;
  background: rgba(243, 218, 107, 0.15);
  color: #F3DA6B;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  flex-shrink: 0;
}
.msg-add-btn {
  color: #E53BB9;
  font-size: 13px;
  font-weight: 500;
  transition: opacity 0.2s ease;
}
.msg-add-btn:hover {
  opacity: 0.8;
}
.msg-action-btn {
  width: 30px;
  height: 30px;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.06);
  color: rgba(255, 255, 255, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  transition: all 0.2s ease;
}
.msg-action-btn:hover {
  background: rgba(255, 255, 255, 0.1);
  color: #fff;
}
.msg-action-delete:hover {
  background: rgba(255, 75, 129, 0.15);
  color: #FF4B81;
}

</style>
